import {startOfDay} from "./startOfDay";

export function isDifferentDay(day1, day2) {
    return startOfDay(day1).getTime() !== startOfDay(day2).getTime();
}